export type SortOption = 'distance' | 'name-asc' | 'name-desc';

interface SortControlsProps {
  value: SortOption;
  onChange: (v: SortOption) => void;
}

export const SortControls = ({ value, onChange }: SortControlsProps) => {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="search-sort" className="text-sm font-medium text-gray-600 whitespace-nowrap">
        Sort:
      </label>
      <select
        id="search-sort"
        value={value}
        onChange={(e) => onChange(e.target.value as SortOption)}
        className="text-sm border border-gray-300 rounded-md px-2 py-1.5 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-info-500 focus:border-info-500"
      >
        <option value="distance">Distance</option>
        <option value="name-asc">Name A-Z</option>
        <option value="name-desc">Name Z-A</option>
      </select>
    </div>
  );
};
